const e=e=>!!(e.altKey||e.ctrlKey||e.metaKey||e.shiftKey);export{e as isModifiedClick};